import { Chip } from '@frameio/vapor';
import TEXT from './generated/TEXT/BetaChip';

TEXT.DEFINE({
  /** Label text for beta chip */
  label: 'Beta',
});

export const BetaChip = () => {
  return (
    <Chip color="green" size="small" variant="ghost">
      {TEXT.label}
    </Chip>
  );
};
